module.exports = __webpack_public_path__ + "img/img-process4@2x.95cdfb65.jpg";